import { getNewTooth, Tooth } from '@modules/teeth-diagram/models/tooth';
import { ToothApi } from '@modules/teeth-diagram/models/tooth-api';

const defaultTooth = getNewTooth();

export const defaultValues = {
	MaterialID: { serverDefault: -1 as number, rxappDefault: defaultTooth.MaterialID },
	SpecificationId: { serverDefault: -1 as number, rxappDefault: defaultTooth.SpecificationId },
	ShadeSystemId: { serverDefault: -1 as number, rxappDefault: defaultTooth.ShadeSystemId },
	UnitTypeID: { serverDefault: -1 as number, rxappDefault: defaultTooth.UnitTypeID },
	ImplantBasedRestorationTypeId: { serverDefault: -1 as number, rxappDefault: defaultTooth.ImplantBasedRestorationTypeId },
	PonticDesignID: { serverDefault: -1 as number, rxappDefault: defaultTooth.PonticDesignID }
} as const;

// Till some moment some values were saved with 0 value on backend if null, could be get from backend.
export const defaultValuesForBackwardCompatibility = {
	ImplantBasedRestorationTypeId: { serverDefault: 0 as number, rxappDefault: defaultTooth.ImplantBasedRestorationTypeId },
	PonticDesignID: { serverDefault: 0 as number, rxappDefault: defaultTooth.PonticDesignID },
	SpecificationId: { serverDefault: 0 as number, rxappDefault: defaultTooth.SpecificationId }
} as const;
type DefaultValuesForBackwardCompatibility = typeof defaultValuesForBackwardCompatibility;

export const defaultValuesToMapFromBackendToRxApp = {
	MaterialID: defaultValues.MaterialID,
	UnitTypeID: defaultValues.UnitTypeID,
	ImplantBasedRestorationTypeId: defaultValues.ImplantBasedRestorationTypeId,
	PonticDesignID: defaultValues.PonticDesignID
} as const;
type DefaultValuesToMapFromBackendToRxApp = typeof defaultValuesToMapFromBackendToRxApp;

export const getToothWithReplacedForRxAppDefault = <T extends Tooth | ToothApi>(tooth: T): T => {
	const updatedTooth = { ...tooth };

	for (const defaultValuesKey of Object.keys(defaultValuesForBackwardCompatibility) as (keyof DefaultValuesForBackwardCompatibility)[]) {
		if (updatedTooth[defaultValuesKey] === defaultValuesForBackwardCompatibility[defaultValuesKey].serverDefault) {
			let rxAppDefaultValue = defaultValuesForBackwardCompatibility[defaultValuesKey].rxappDefault;

			if (typeof rxAppDefaultValue === 'string') {
				rxAppDefaultValue = Number(rxAppDefaultValue);
			}

			updatedTooth[defaultValuesKey] = rxAppDefaultValue;
		}
	}

	for (const defaultValuesKey of Object.keys(defaultValuesToMapFromBackendToRxApp) as (keyof DefaultValuesToMapFromBackendToRxApp)[]) {
		if (updatedTooth[defaultValuesKey] === defaultValuesToMapFromBackendToRxApp[defaultValuesKey].serverDefault) {
			let rxAppDefaultValue = defaultValuesToMapFromBackendToRxApp[defaultValuesKey].rxappDefault;

			if (typeof rxAppDefaultValue === 'string') {
				rxAppDefaultValue = Number(rxAppDefaultValue);
			}

			updatedTooth[defaultValuesKey] = rxAppDefaultValue;
		}
	}

	return updatedTooth;
};
